module.exports = __webpack_public_path__ + "cmslogo.png?5adafd5f0debf29888bf69330b17af8d";